"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_formatter_1 = require("currency-formatter");
var CsvUploader_1 = __importDefault(require("./CsvUploader"));
var GetDescriptionHtml_1 = __importDefault(require("QuoteV2/Adapter/GetDescriptionHtml"));
var lodash_1 = __importDefault(require("lodash"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
function default_1(invoke, make, $q, overlayStack, createUi, savedLineItems, variableService, savedLineItemsLibrary, currentCurrency, Tooltip, $sce, labelService, billingScheduleOrchestrator) {
    var selectionDeferral = $q.defer();
    var currencyClashWarning = make(Tooltip, {
        targetSelector: ".saved-line-items .button-primary",
        options: {
            stringContent: "The currency of some selected items are not the same as this project's currency",
            position: "bottom",
            container: ".top-bar",
            customTheme: "error-theme",
            spacing: 5,
        },
    });
    var uploadInstructionsTooltipUi = invoke(require("./UploadInstructionsTooltip"));
    make(Tooltip, {
        targetSelector: ".saved-line-items .button-add",
        options: {
            contents: uploadInstructionsTooltipUi,
            position: "bottom",
            container: ".top-bar",
            customTheme: "helper-theme",
            spacing: 10,
            showOnHover: true,
        },
    });
    var cleanSelection = function (items) {
        var cleanItems = lodash_1.default.cloneDeep(items);
        return lodash_1.default.map(cleanItems, function (item) {
            delete item.currency;
            delete item.id;
            return item;
        });
    };
    var cacheDescriptionHtml = function (item) {
        item.$descriptionHtml = (0, GetDescriptionHtml_1.default)(item.description);
        if (item.description.tokens) {
            return (item.$descriptionHtml = $sce.trustAsHtml(item.$descriptionHtml));
        }
    };
    var ui = createUi(require("./SavedLineItemsOverlay.html"), {
        savedLineItems: savedLineItems,
        searchTerm: "",
        select: function (item) {
            item.$selected = !item.$selected;
            ui.validateForClashingCurrency();
        },
        hasSelection: function () {
            var e_1, _a;
            try {
                for (var _b = __values(ui.savedLineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    if (item.$selected) {
                        return true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return false;
        },
        validateForClashingCurrency: function () {
            var e_2, _a;
            if (currentCurrency === "" && currencyClashWarning.isCurrentlyShowing()) {
                currencyClashWarning.hide();
                return;
            }
            var selection = ui.getSelection();
            try {
                for (var selection_1 = __values(selection), selection_1_1 = selection_1.next(); !selection_1_1.done; selection_1_1 = selection_1.next()) {
                    var item = selection_1_1.value;
                    if (item.currency != null && item.currency !== currentCurrency && item.type !== "text") {
                        if (!currencyClashWarning.isCurrentlyShowing()) {
                            currencyClashWarning.show();
                        }
                        else {
                            return;
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (selection_1_1 && !selection_1_1.done && (_a = selection_1.return)) _a.call(selection_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            if (currencyClashWarning.isCurrentlyShowing()) {
                return currencyClashWarning.hide();
            }
        },
        getSelection: function () {
            return lodash_1.default.filter(ui.savedLineItems, { $selected: true });
        },
        finishSelecting: function () {
            if (!ui.hasSelection()) {
                return;
            }
            selectionDeferral.resolve(cleanSelection(ui.getSelection()));
            return overlayStack.closeCurrent();
        },
        deleteItem: function (item) {
            return savedLineItemsLibrary.deleteLineItem(item.id);
        },
        addLineItemsButtonText: function () {
            var selection = ui.getSelection();
            if (selection.length === 0) {
                return "Add line items";
            }
            else if (selection.length === 1) {
                return "Add 1 line item";
            }
            else {
                return "Add ".concat(selection.length, " line items");
            }
        },
        getDescription: function (item) {
            if (item.$descriptionHtml == null) {
                cacheDescriptionHtml(item);
            }
            return item.$descriptionHtml;
        },
        getRate: function (item) {
            if (item.type === "variable") {
                var variable = variableService.getVariable(item.rate.variableId);
                return variable.name;
            }
            else if (item.type === "fixedCost") {
                return "".concat((0, currency_formatter_1.format)(item.rate.rate, { code: item.currency }), " x ").concat(item.rate.unit);
            }
            else {
                return "";
            }
        },
        getQuantityAmount: function (item) {
            if (item.type === "variable" || item.type === "fixedCost") {
                return item.quantity;
            }
            else {
                return "";
            }
        },
        getQuantityUnit: function (item) {
            if (item.type === "variable") {
                var variable = variableService.getVariable(item.rate.variableId);
                return variable.unitName;
            }
            else if (item.type === "fixedCost") {
                return item.rate.unit;
            }
            else {
                return "";
            }
        },
        getPrice: function (item) {
            if (item.type === "variable") {
                var variable = variableService.getVariable(item.rate.variableId);
                return (0, currency_formatter_1.format)(item.quantity * variable.getAmount(item.quantity), {
                    code: item.currency,
                });
            }
            else if (item.type === "fixedCost") {
                return (0, currency_formatter_1.format)(item.quantity * item.rate.rate, {
                    code: item.currency,
                });
            }
            else {
                return "";
            }
        },
        showRecurrence: function (item) {
            return !!ui.getRecurrence(item);
        },
        getRecurrence: function (item) {
            if (!(0, Types_1.isPricedQuoteItem)(item)) {
                return "";
            }
            var billingSchedule = billingScheduleOrchestrator.getBillingSchedule(item);
            if ((0, Types_1.isRecurringSchedule)(billingSchedule)) {
                var label = (0, Recurrence_1.mapRecurringFrequencyToPerLabel)(billingSchedule.frequency);
                return labelService.getLabel(null, label);
            }
            return "";
        },
        uploadCsv: function (file) {
            if (file != null) {
                var csvUploader = invoke(CsvUploader_1.default);
                return csvUploader($q, file)
                    .then(function (newLineItems) { return savedLineItemsLibrary.saveLineItems(currentCurrency, newLineItems); })
                    .catch(function () {
                    var errorTooltipContent = invoke(require("./CsvErrorTooltip"));
                    var errorTooltip = make(Tooltip, {
                        targetSelector: ".saved-line-items .button-add",
                        options: {
                            contents: errorTooltipContent,
                            container: ".top-bar",
                            customTheme: "error-theme",
                            position: "bottom",
                            spacing: 5,
                            hideAfter: 4000,
                        },
                    });
                    return errorTooltip.show();
                });
            }
        },
        close: function () {
            overlayStack.closeCurrent();
            return selectionDeferral.resolve([]);
        },
    });
    overlayStack.add({
        contentUi: ui,
        options: {
            centerContent: false,
            hideCloseButton: true,
        },
    });
    return selectionDeferral.promise;
}
exports.default = default_1;
